import GeRealtimeCompareTimeGroupNew from "./GeRealtimeCompareTimeGroupNew";
// import { GeRealtimeCompareTimeGroupNew } from '@jd/jmtd-pro';

export default function RealtimeCompareTimeGroup() {
    return GeRealtimeCompareTimeGroupNew({
        menuCode: 'flowSummary'
    });
}
